import { Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './styled';

export const EmptyPlan = ({ copy }: { copy: { title: string; description: string } }) => {
    return (
        <S.Container data-testid="empty-plan">
            <Text type="h5" mb={16}>
                {copy.title}
            </Text>
            <Text type="large-text-medium" color="text-secondary">
                {copy.description}
            </Text>
        </S.Container>
    );
};
